module.exports = __webpack_public_path__ + "static/recurrence-chart-1c9a4ae8420179db6b84bb7de39b1816.png";